/**
 * LP header behavior (sections/medispa-lp-header.liquid): sticky hide-on-
 * scroll-down / reveal-on-scroll-up, and the cart button opening the
 * mini-cart. Loaded by deferred-scripts.liquid (marker: data-medispa-lp-header).
 */
import { onDomReady } from '@/components/utils/medispa-lp';

const HIDE_THRESHOLD = 80;

function initHeader(header: HTMLElement): void {
  const stickyTarget =
    header.closest<HTMLElement>('.medispa-lp-header-wrapper') ||
    header.closest<HTMLElement>('.shopify-section') ||
    header;

  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateHeader = (): void => {
    const currentScrollY = window.scrollY;

    if (currentScrollY <= HIDE_THRESHOLD) {
      stickyTarget.classList.remove('is-hidden');
    } else if (currentScrollY > lastScrollY) {
      stickyTarget.classList.add('is-hidden');
    } else if (currentScrollY < lastScrollY) {
      stickyTarget.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    },
    { passive: true },
  );

  const cartButton = header.querySelector('[data-medispa-lp-header-cart]');

  cartButton?.addEventListener('click', (event) => {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('mini-cart:ui:open'));
  });
}

onDomReady(() => {
  document.querySelectorAll<HTMLElement>('[data-medispa-lp-header]').forEach(initHeader);
});
